/**
 * zrender: 生成唯一id
 *
 * @author errorrik (errorrik@gmail.com)
 */
var idStart = 0x0907;

function _default() {
  return idStart++;
}

module.exports = _default;


//////////////////
// WEBPACK FOOTER
// ../~/zrender/lib/core/guid.js
// module id = 4R45
// module chunks = 0